import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./CommonSectionFeatured.module.scss";
import Image from "@Components/Image";
import getImagePath from "@Utils/getImagePath";
import useWhitelabel from "hooks/useWhitelabel";
import wrapperHOC from "@Utils/wrapperHOC";
import replaceAmberDomainInLinks from "@Utils/clientUtils/dangerouslySetInnerHtmlUtility/replaceAmberDomainInLinks";
import useIsMiniProgram from "hooks/useIsMiniProgram";

function CommonSectionFeatured({
  title,
  subheading,
  bgUrl,
  extraClass,
  isDesktop = false,
  bgSize = "cover",
}: any) {
  const { isWhitelabel } = useWhitelabel();
  const isMiniProgram = useIsMiniProgram();
  return (
    <div
      className={formatClassNames(
        isDesktop
          ? styles["desktop-section-featured-container"]
          : styles["section-featured-container"],
        isWhitelabel && styles.whitelabelHeader,
      )}
    >
      <Image
        src={getImagePath(bgUrl, "", { h: isDesktop ? "450" : "364" })}
        isEagerLoad={!isMiniProgram}
        className={styles.sectionFeaturedImg}
        alt="section featured image"
        width="100%"
        height="100%"
        style={{ objectFit: bgSize }}
      />
      <div
        className={formatClassNames(
          isDesktop
            ? styles["desktop-section-featured-inner-container"]
            : styles["section-featured-inner-container"],
          styles[extraClass],
        )}
      >
        {/* heading */}
        {title && (
          <h1
            className={isDesktop ? styles["desktop-featured-heading"] : styles["featured-heading"]}
            dangerouslySetInnerHTML={{ __html: replaceAmberDomainInLinks(title) }}
          />
        )}

        {/* subheading */}
        {subheading && (
          <h2
            className={
              isDesktop ? styles["desktop-featured-subheading"] : styles["featured-subheading"]
            }
            dangerouslySetInnerHTML={{ __html: replaceAmberDomainInLinks(subheading) }}
          />
        )}
      </div>
    </div>
  );
}

export default wrapperHOC(CommonSectionFeatured, {
  componentName: "CommonSectionFeatured",
  showForChina: true,
});
